<template>
    <div>
    <sweet-modal blocking :title="$t('modal_createBusinessUnitTaskProgress')" width="780px" ref="createBusinessUnitTaskProgress" class="modal" v-on:close="closeModal">
        <el-form label-position="left" :model="formcreateBusinessUnitTaskProgress" status-icon :rules="rules" ref="formcreateBusinessUnitTaskProgress" label-width="100px" class="demo-ruleForm">

            <template v-if="parentBill">
                <el-form-item label-width="0">
                    <el-switch v-model="formcreateBusinessUnitTaskProgress.isBillable" :active-text="$t('modal_billing')"></el-switch>
                </el-form-item>

                <el-row v-if="formcreateBusinessUnitTaskProgress.isBillable" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="assignmentsId" label-width="0">
                            <el-select v-model="formcreateBusinessUnitTaskProgress.assignmentsId" :placeholder="$t('modal_assignments')" clearable style="width: 100%;">
                            <el-option v-for="item in formcreateBusinessUnitTaskProgress.assignments"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                @click.native="selectAssignments(item)">
                            </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="activitiesId" label-width="0">
                            <el-select v-model="formcreateBusinessUnitTaskProgress.activitiesId" :placeholder="$t('modal_activities')" clearable style="width: 100%;">
                            <el-option v-for="item in formcreateBusinessUnitTaskProgress.activities"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row v-if="formcreateBusinessUnitTaskProgress.isBillable">
                    <el-col :span="24">
                    <el-form-item label-width="0" prop="title">
                        <el-input v-model="formcreateBusinessUnitTaskProgress.title" :label="$t('modal_shortNote')"></el-input>
                    </el-form-item>
                    </el-col>
                </el-row>
            </template>

            <el-form-item class="text-block" label-position="top" label-width="0">
                <vue-editor v-model="formcreateBusinessUnitTaskProgress.text" useCustomImageHandler @image-added="handleImageAdded"></vue-editor>
                <!--<el-input type="textarea" placeholder="Text" v-model="formcreateBusinessUnitTaskProgress.text"></el-input>-->
            </el-form-item>
            <!--{{selectedRow}}-->
            <div class="reminder-block">
                <el-form-item :label="$t('modal_timeSpent')">
                    <el-time-picker
                        v-model="formcreateBusinessUnitTaskProgress.timeSpent"
                        value-format='HHmm'
                        format='HH:mm'
                        :picker-options="{
                            align: 'center'
                        }"
                        placeholder="Arbitrary time">
                    </el-time-picker>
                </el-form-item>
                <div class="reminder-block_date">
                    <el-form-item prop="isReminderActive" :label="$t('modal_setReminder')" label-width="120px">
                        <el-checkbox name="type" @change="isReminderActiveChange(formcreateBusinessUnitTaskProgress.isReminderActive)" v-model="formcreateBusinessUnitTaskProgress.isReminderActive"></el-checkbox>
                    </el-form-item>
                    <el-form-item prop="reminderDate" label-width="20px">
                        <el-date-picker
                                format="d MMM yy h : mm A"
                                :disabled="!formcreateBusinessUnitTaskProgress.isReminderActive"
                                v-model="formcreateBusinessUnitTaskProgress.reminderDate"
                                type="datetime"
                                :placeholder="$t('modal_pickADate')"
                                value-format="timestamp"
                        >
                        </el-date-picker>
                    </el-form-item>
                </div>
                <!--<el-button slot="trigger" v-on:click="$refs.formReminder.open()" size="small" type="primary">Set Reminder</el-button>-->
            </div>
            <!--<div class="remider">-->
                <!--<el-button slot="trigger" v-on:click="$refs.formReminder.open()" size="small" type="primary">Set Reminder</el-button>-->
            <!--</div>-->
            <!-- <div class="upload-media">
                <el-upload
                        class="upload-demo"
                        ref="upload"
                        action=""
                        :auto-upload="false"
                        :file-list="fileList">
                    <el-button slot="trigger" size="small" type="primary">Add Media</el-button>
                </el-upload>
            </div> -->
            <el-form-item :label="$t('modal_progress')" prop="Progress" >
                <el-slider
                        v-model="formcreateBusinessUnitTaskProgress.progress"
                        :max="100"
                        :min="0"
                        :step="5"
                        show-stops>
                </el-slider>
            </el-form-item>

            <!-- <el-form-item label="Hours spent">
                <el-input placeholder="Hours spent" v-model="formcreateBusinessUnitTaskProgress.hoursSpent"></el-input>
            </el-form-item>
            <el-form-item label="Minutes spent">
                <el-input placeholder="Minutes spent" v-model="formcreateBusinessUnitTaskProgress.minutesSpent"></el-input>
            </el-form-item> -->
            <div class="flex-twocolumn">
                <el-form-item label-width="0">
                    <el-switch v-model="formcreateBusinessUnitTaskProgress.notifyBusinessUnitTeam" :active-text="$t('modal_notify_bu_manager')"></el-switch>
                </el-form-item>
                <el-form-item label-width="0">
                    <el-switch v-model="formcreateBusinessUnitTaskProgress.notifyTaskTeam"></el-switch> {{$t('modal_notifyTaskTeam')}}
                </el-form-item>
                <el-form-item label-width="0">
                    <el-switch :disabled="allowNotification || !businessUnitPermission.addProgressNotifyClients" v-model="formcreateBusinessUnitTaskProgress.notifyClients"></el-switch> {{$t('modal_notifyClients')}}
                </el-form-item>
                <el-form-item label-width="0">
                    <el-switch :disabled="allowNotification || !businessUnitPermission.addProgressNotifyVendors" v-model="formcreateBusinessUnitTaskProgress.notifyVendors"></el-switch> {{$t('modal_notifyVendors')}}
                </el-form-item>
            </div>
            <div class="flex-end">
                <el-form-item class="modal__btn">
                    <el-button @click="modalCancel('createBusinessUnitTaskProgress')">{{$t('general_cancel')}}</el-button>
                    <el-button @click="createBusinessUnitTaskProgressSubmit('formcreateBusinessUnitTaskProgress')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </div>
        </el-form>
        <!--{{formcreateBusinessUnitTaskProgress}}-->
    </sweet-modal>
    <!--<sweet-modal  ref="formReminder" v-on:close="closeReminder">-->
        <!--<el-form :model="formReminder">-->
            <!--<el-form-item label="Set Reminder" label-width="120px" prop="date">-->
                <!--<el-date-picker-->
                        <!--v-model="formReminder.reminder"-->
                        <!--type="date"-->
                        <!--placeholder="Pick a date"-->
                        <!--value-format="ddMMyyyy"-->
                <!--&gt;-->
                <!--</el-date-picker>-->
            <!--</el-form-item>-->
            <!--<el-form-item>-->
                <!--<vue-editor v-model="formReminder.description"></vue-editor>-->
            <!--</el-form-item>-->
            <!--<el-form-item>-->
                <!--<el-button @click="setReminderSubmit" class="modal__btn" type="primary" plain size="medium">Set reminder</el-button>-->
            <!--</el-form-item>-->
        <!--</el-form>-->
    <!--</sweet-modal>-->
    </div>
</template>

<script>
    import { VueEditor } from 'vue2-editor'
    import { SweetModal } from '@totalflow4/tfsweet-modal-vue';

    import axios from 'axios';

    export default {
        components: {
            SweetModal,

            VueEditor
        },
        props: [
            'selectedRow',
          'allowNotification',
          'businessUnitPermission',
          'parentBill',
          'assignmentList',
        ],
        mounted() {
          this.createBusinessUnitTaskProgressOpen();
          this.formcreateBusinessUnitTaskProgress.progress = this.selectedRow.progress
        },
        data() {
          var checkDate = (rule, value, callback) => {
            if (!value && this.formcreateBusinessUnitTaskProgress.isReminderActive) {
              return callback(new Error('Please input the date'));
            }else callback();
          };
            return {
                businessUnitTaskId: 0,
                fileList:[],
                formcreateBusinessUnitTaskProgress: {
                    isBillable: true,
                    activitiesId: null,
                    activities: [],
                    assignmentsId: null,
                    assignments: [],

                    reminder:'',
                    progress: 0,
                    text: '',
                    timeSpent: '0000',
                    hoursSpent: 0,
                    minutesSpent: 0,
                    notifyProjectTeam: false,
                    notifyTaskTeam: true,
                    notifyClients: false,
                    notifyVendors: false,
                    isReminderActive: false,
                    reminderDate: '',
                    notifyBusinessUnitTeam: false,
                    title: '',
                },
              rules: {
                reminderDate: [{ validator: checkDate, trigger: 'blur' }]
              }
                // formReminder:{
                //     reminder:'',
                //     description:''
                // },
            };
        },
        methods: {
            selectAssignments(item) {
                this.formcreateBusinessUnitTaskProgress.activitiesId = null
                this.formcreateBusinessUnitTaskProgress.activities = item.activities
            },
            modalCancel(ref) {
                this.$refs[ref].close();
            },
          isReminderActiveChange(value){
            if(!value){
              this.$refs['formcreateBusinessUnitTaskProgress'].resetFields();
            }
          },
            closeModal() {
                this.formcreateBusinessUnitTaskProgress.text = ''
                this.formcreateBusinessUnitTaskProgress.hoursSpent = 0
                this.formcreateBusinessUnitTaskProgress.minutesSpent = 0
                this.formcreateBusinessUnitTaskProgress.notifyProjectTeam = false
                this.formcreateBusinessUnitTaskProgress.notifyTaskTeam = true
                this.formcreateBusinessUnitTaskProgress.notifyClients = false
                this.formcreateBusinessUnitTaskProgress.notifyVendors = false
                this.formcreateBusinessUnitTaskProgress.reminderDate = ''
                this.formcreateBusinessUnitTaskProgress.isReminderActive = false
                this.formcreateBusinessUnitTaskProgress.timeSpent = '0000'
                this.formcreateBusinessUnitTaskProgress.notifyBusinessUnitTeam = false
                this.formcreateBusinessUnitTaskProgress.isBillable = true
                this.formcreateBusinessUnitTaskProgress.activitiesId = null
                this.formcreateBusinessUnitTaskProgress.assignmentsId = null

            },
            notification(title, message, type) {
                this.$notify({
                    title: title,
                    message: message,
                    type: type,
                });
            },

            createBusinessUnitTaskProgressOpen() {
            },

            createBusinessUnitTaskProgressSubmit(form) {
              if(!this.formcreateBusinessUnitTaskProgress.progress){
                return this.notification(this.$t('general_warning'), this.$t('modal_addProgressNote_progressCannotBeNull'), "info")
              }
              if(this.formcreateBusinessUnitTaskProgress.progress < this.selectedRow.progress){
                return this.notification(this.$t('general_warning'), this.$t('modal_addProgressNote_progressCannotBeLess'), "info")
              }
                console.log('---', 'submit create');
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        let loader = this.$loading.show();

                        if (this.formcreateBusinessUnitTaskProgress.timeSpent) {
                            let time, hours, minutes;
                            time = this.formcreateBusinessUnitTaskProgress.timeSpent;
                            hours = time.slice(0, 2);
                            minutes = time.slice(2, 4);
                            this.formcreateBusinessUnitTaskProgress.hoursSpent = hours
                            this.formcreateBusinessUnitTaskProgress.minutesSpent = minutes
                        }
                      if(this.formcreateBusinessUnitTaskProgress.reminderDate === ''){
                        this.formcreateBusinessUnitTaskProgress.reminderDate = null
                      }
                      if (!this.formcreateBusinessUnitTaskProgress.isBillable) {
                            this.formcreateBusinessUnitTaskProgress.title = ''
                            this.formcreateBusinessUnitTaskProgress.activitiesId = null
                            this.formcreateBusinessUnitTaskProgress.assignmentsId = null
                        }
                        axios
                            .post(`/api/v1/businessUnitTaskProgresses/create?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&businessUnitTaskId=${this.businessUnitTaskId}`,{
                                text: this.formcreateBusinessUnitTaskProgress.text,
                                progress: this.formcreateBusinessUnitTaskProgress.progress,
                                notifyBusinessUnitTeam: this.formcreateBusinessUnitTaskProgress.notifyBusinessUnitTeam,
                                notifyTaskTeam: this.formcreateBusinessUnitTaskProgress.notifyTaskTeam,
                                notifyClients: this.formcreateBusinessUnitTaskProgress.notifyClients,
                                notifyVendors: this.formcreateBusinessUnitTaskProgress.notifyVendors,
                                hoursSpent: this.formcreateBusinessUnitTaskProgress.hoursSpent,
                                minutesSpent: this.formcreateBusinessUnitTaskProgress.minutesSpent,
                                isReminderActive: this.formcreateBusinessUnitTaskProgress.isReminderActive,
                                reminderDate: this.formcreateBusinessUnitTaskProgress.reminderDate / 1000,
                                title: this.formcreateBusinessUnitTaskProgress.title,
                                timer: false,
                                isBillable: this.parentBill ? this.formcreateBusinessUnitTaskProgress.isBillable : false,
                                activityId: this.formcreateBusinessUnitTaskProgress.activitiesId,
                                assignmentId: this.formcreateBusinessUnitTaskProgress.assignmentsId,
                            })
                            .then(response => {
                                this.$refs.createBusinessUnitTaskProgress.close();
                                this.$store.dispatch('getDepProgressesList', this.businessUnitTaskId);
                                loader.hide();
                                this.notification(this.$t('general_success'), this.$t('modal_businessUnit_addProgressNote_createBusinessUnitTaskProgress'), "success");
                                this.$emit('submit')
                            })
                            .catch(error => {
                                loader.hide()
                                //this.notification("Notification", "Invalid email value", "warning");
                            });
                      if(this.formcreateBusinessUnitTaskProgress.reminder.length){
                        axios
                          .post(`/api/v1/reminders/create`, {
                            date: this.formcreateBusinessUnitTaskProgress.reminder,
                          })
                          .then(response => {
                            if(response.data.success){
                              console.log("reminder response", response.data)
                            }
                          })
                          .catch(error => {
                            loader.hide()
                          });
                      }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
          // closeReminder(){
          //   this.formReminder.description = ''
          //   this.formReminder.reminder = ''
          // },
          // setReminderSubmit(){
          //   console.log('SET REMINDER')
          //   axios
          //     .post(`/api/v1/reminders/create`, {
          //       date: this.formReminder.reminder,
          //       text: this.formReminder.description,
          //       entityType: localStorage.getItem('selectedProjectId'),
          //       entityId: this.selectedRow.id
          //     })
          //     .then(response => {
          //       if(response.data.success){
          //         this.$refs.formReminder.close();
          //         this.notification("Success", "Reminder successfully sent", "success");
          //         console.log("reminder response", response.data)
          //       }
          //     })
          //     .catch(error => {
          //       loader.hide()
          //       this.$refs.formReminder.close();
          //       this.notification("Notification", error.response.data.message, "warning")
          //     });
          // },
          close(){
            this.formcreateBusinessUnitTaskProgress.text = ''
            this.formcreateBusinessUnitTaskProgress.hoursSpent = 0
            this.formcreateBusinessUnitTaskProgress.minutesSpent = 0
            this.formcreateBusinessUnitTaskProgress.notifyProjectTeam = 0
            this.formcreateBusinessUnitTaskProgress.notifyTaskTeam = 0
            this.formcreateBusinessUnitTaskProgress.notifyClients = 0
            this.formcreateBusinessUnitTaskProgress.notifyVendors = 0
            this.formcreateBusinessUnitTaskProgress.reminderDate = ''
            this.formcreateBusinessUnitTaskProgress.isReminderActive = false
            this.formcreateBusinessUnitTaskProgress.timeSpent = '0000'
          },
          handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
                let loader = this.$loading.show();
                console.log("FILE",file);
                // this.form.imageUrl = URL.createObjectURL(file.raw);
                // console.log('---', this.form.imageUrl);
                var formData = new FormData();
                formData.append('file', file);

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios
                        .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
                        .then(response => {
                            let url = response.data.fileUrl // Get url from response
                            Editor.insertEmbed(cursorLocation, 'image', url);
                            resetUploader();
                            loader.hide()
                        })
                        .catch(error => {
                            console.log('An error occurred:', error);
                            loader.hide()
                        })
            }
        },
      watch:{
        selectedRow(sed){
          console.log(sed)
          this.formcreateBusinessUnitTaskProgress.progress = sed.progress
        },
        assignmentList(val) {
            this.formcreateBusinessUnitTaskProgress.assignments = val
        },
      }
    };
</script>

<style lang="less" scoped>
    .text-block{
        display:flex;
        flex-direction:column;
    }
    .reminder-block{
        justify-content: space-between;
        display:flex;
        &_date{
            display:flex;
        }
    }
    .reminder-datepicker{
        margin-left:0;
    }
    .flex-end{
        display:flex;
        justify-content:flex-end;
    }
    .sweet-modal-overlay{
        z-index:1000;
    }
    .remider{
        margin-bottom:10px;
        display:flex;
        justify-content:flex-end;
    }
    .upload-media{
        display:flex;
        justify-content:flex-end;
    }
</style>
<style lang="less">
    .flex-twocolumn{
        display:flex;
        .el-form-item__content{
            margin:0 12px;
            font-size:13px;
        }
    }
    .reminder-block{
        .el-date-editor.el-input{
            width: 160px;
        }
    }
</style>
